import React from 'react';
import ReactDOM from 'react-dom';
import {ThemeProvider} from '@material-ui/core/styles';
import theme from './theme';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import RTL from './components/RTL';
ReactDOM.render(
  <React.StrictMode>
    <RTL>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </RTL>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
